import { ThreadMemberScope } from '@dialectlabs/sdk';
export function isWritable(scopes) {
    return scopes.includes(ThreadMemberScope.WRITE);
}
export function isAdminable(scopes) {
    return scopes.includes(ThreadMemberScope.ADMIN);
}
//# sourceMappingURL=scopes.js.map